import {
    HomeIcon,
    ChartBarIcon,
    CurrencyDollarIcon,
    NewspaperIcon
} from '@heroicons/react/24/outline';

/**
 * Navigation menu items configuration
 * Used in Sidebar and Navbar components
 */
export const NAV_LINKS = [
    {
        path: '/',
        label: 'Home',
        icon: HomeIcon
    },
    {
        path: '/cryptos',
        label: 'Cryptocurrencies',
        icon: CurrencyDollarIcon
    },
    {
        path: '/exchanges',
        label: 'Exchanges',
        icon: ChartBarIcon
    },
    {
        path: '/news',
        label: 'News',
        icon: NewspaperIcon
    }
];
